import React from "react";

export const ProductSuiteIcon: React.FC = () => {
  return (
    <span
      aria-hidden="true"
      style={{
        display: "inline-grid",
        gridTemplateColumns: "repeat(3, 7px)",
        gridTemplateRows: "repeat(3, 7px)",
        gap: "3px",
        padding: "2px",
      }}
    >
      {[
        ["#5f6878", "#9aa4b3"],
        ["#667180", "#a1abb9"],
        ["#717b8a", "#adb7c4"],
        ["#6a7584", "#a6b0be"],
        ["#7b8492", "#b2bcc9"],
        ["#8a93a1", "#c0c8d3"],
        ["#656f7d", "#9ea8b6"],
        ["#747e8c", "#b0bac6"],
        ["#848d9a", "#c1cad5"],
      ].map(([base, top], index) => (
        <span
          key={index}
          style={{
            width: 7,
            height: 7,
            borderRadius: 2,
            background: `linear-gradient(145deg, ${top}, ${base})`,
            boxShadow:
              "0 1px 0 rgba(255,255,255,0.28), 0 2px 4px rgba(15,23,42,0.2), inset 0 1px 0 rgba(255,255,255,0.34), inset 0 -1px 0 rgba(0,0,0,0.12)",
            position: "relative",
          }}
        />
      ))}
    </span>
  );
};

export default ProductSuiteIcon;
